import { render, staticRenderFns } from "./Salerole.vue?vue&type=template&id=734c4e36"
import script from "./Salerole.vue?vue&type=script&lang=js"
export * from "./Salerole.vue?vue&type=script&lang=js"
import style0 from "./Salerole.vue?vue&type=style&index=0&id=734c4e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports